/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsubline2Inputs */

const en_placewebsubline2 = /** @type {(inputs: Placewebsubline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify reads your website and fills in the name, address, opening hours, contact details and photos. A complete profile helps people find you faster on Google and in AI search like ChatGPT, Claude or Perplexity.`)
};

const de_placewebsubline2 = /** @type {(inputs: Placewebsubline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify liest deine Website und füllt Name, Adresse, Öffnungszeiten, Kontakt und Fotos aus. Ein vollständiges Profil hilft, dass man dich bei Google und in KI-Suchen wie ChatGPT, Claude oder Perplexity schneller findet.`)
};

/**
* | output |
* | --- |
* | "Pulsify reads your website and fills in the name, address, opening hours, contact details and photos. A complete profile helps people find you faster on Goog..." |
*
* @param {Placewebsubline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsubline2 = /** @type {((inputs?: Placewebsubline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsubline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsubline2(inputs)
	return de_placewebsubline2(inputs)
});
export { placewebsubline2 as "placeWebSubline" }